import React, { Component } from 'react';
import Table from '../Tables/SupportTable';
import BestDev from '../Tables/bestDev';


class WrapperBestDevTable extends Component {


    render() {
        return(
            <div>
                <div style={{float:'left'}}>
                    <Table/>
                </div>
                <div style={{float:'left'}}>
                    <BestDev/>
                </div>
            </div>
        )
    }
}

export default (WrapperBestDevTable);



// WEBPACK FOOTER //
// ./src/components/Wrapper/WrapperBestDevTable.js